import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDictionary } from '@adamlip/okeoke.client';

export default function CurrentOpenHours({ location }) {
  const { getValue } = useDictionary();
  const [currentOpenHours, setCurrentOpenHours] = useState(null);

  useEffect(() => {
    if (location?.attributes?.openHours) {
      let today = location?.attributes?.openHours?.[moment().isoWeekday()];

      if (today.closed) {
        setCurrentOpenHours(getValue('app_v2_location_closed'));
      } else {
        setCurrentOpenHours(`${today?.from?.hour || '00'}:${today?.from?.minute || '00'}-${today?.to?.hour || '00'}:${today?.to?.minute || '00'}`);
      }
    }
    //eslint-disable-next-line
  }, [location]);

  if (!location?.attributes?.openHours) return null;

  return <div className=''>{currentOpenHours}</div>;
}
